import StorageKeys from 'enum/storages.enum';
import Storages from 'storages';

function isDemoMode() {
  return process.env.REACT_APP_DEMO_MODE === 'true';
}

function getTimeForScreens() {
  return process.env.REACT_APP_SCREEN_WAIT_TIME || 2000;
}

function getApiURL() {
  let url = Storages.MainStorage.getItem(StorageKeys.Keys.PROXYURL);
  let ignoreProxy = Storages.MainStorage.getItem(StorageKeys.Keys.IGNORE_PROXY);
  url = url && url !== '' && !ignoreProxy ? url : process.env.REACT_APP_API_BASE_URL;
  // return "http://10.10.0.74:8000"
  // return "http://192.168.0.103:8000"
  // return "http://127.0.0.1:8000"
  return url;

  // return "http://10.10.0.33/api"
  //  return "http://45.32.13.69/iptv"
}

function getSocketUrl() {
  let apiUrl = getApiURL();
  apiUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;

  // Choose WS scheme securely based on API URL or page protocol
  const isPageSecure =
    typeof window !== 'undefined' && window.location && window.location.protocol === 'https:';
  const forceWss = String(process.env.REACT_APP_FORCE_WSS || '').toLowerCase() === 'true';

  let socketUrl;
  if (/^http(s?):\/\//i.test(apiUrl)) {
    // http -> ws, https -> wss
    socketUrl = apiUrl.replace(/^http(s?):\/\//i, 'ws$1://');
  } else if (/^ws(s?):\/\//i.test(apiUrl)) {
    socketUrl = apiUrl;
  } else {
    // No scheme provided: default to wss on secure pages or when forced
    const scheme = forceWss || isPageSecure ? 'wss' : 'ws';
    socketUrl = `${scheme}://${apiUrl}`;
  }
  return `${socketUrl}/chl/notifications/`;
}

function getGoogleCastSDKId() {
  return process.env.REACT_APP_GOOGLE_CAST_SDK_APP_ID;
}

function isChannelOnly() {
  return process.env.REACT_APP_CHANNEL_ONLY === 'true';
}

function isCastingEnabled() {
  return process.env.REACT_APP_ENABLE_CAST === 'true';
}

const obj = {
  getApiURL,
  getTimeForScreens,
  getGoogleCastSDKId,
  getSocketUrl,
  isDemoMode,
  isChannelOnly,
  isCastingEnabled
};

export default obj;
